module.exports = __webpack_public_path__ + "img/subBanner14.1e954204.png";